export default __webpack_public_path__ + "779a23fb2425565eb9277eef58e959d3.png";